import { render, staticRenderFns } from "./backup-restore.component.vue?vue&type=template&id=2da0739a"
import script from "./backup-restore.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-restore.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da0739a')) {
      api.createRecord('2da0739a', component.options)
    } else {
      api.reload('2da0739a', component.options)
    }
    module.hot.accept("./backup-restore.component.vue?vue&type=template&id=2da0739a", function () {
      api.rerender('2da0739a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/backup-settings/backup-restore.component.vue"
export default component.exports